module.exports = __webpack_public_path__ + "img/qr-code-counter-bar.f05493db.jpg";